// @flow

export default (t: (id: string, obj?: Object) => string) => ({
  id: {
    "ui:widget": "hidden",
  },
  "ui:order": ["name", "address", "reseller", "accountManager", "status", "inTesting", "*"],
  address: {
    "ui:order": ["addressLine1", "postCode", "*"],
    addressLine1: {
      "ui:options": {
        label: t("CLIENT_ADDRESS"),
        description: t("CLIENT_ADDRESS_DESCRIPTION"),
        className: "mb-2",
      },
    },
    addressLine2: {
      "ui:widget": "hidden",
    },
    addressLine3: {
      "ui:widget": "hidden",
    },
    city: {
      "ui:widget": "hidden",
    },
    postCode: {
      "ui:options": {
        description: t("CLIENT_POST_CODE_DESCRIPTION"),
      },
    },
  },
  country: {
    id: {
      "ui:widget": "hidden",
    },
    "ui:widget": "hidden",
  },
  region: {
    id: {
      "ui:widget": "hidden",
    },
    "ui:widget": "hidden",
  },
  name: {
    "ui:options": {
      description: t("CLIENT_NAME_DESCRIPTION"),
    },
  },
  inTesting: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("SUPPRESSION"),
      description: t("CLIENT_SUPPRESSION_DESCRIPTION"),
    },
  },
  accountManager: {
    id: {
      "ui:options": {
        label: t("ACCOUNT_MANAGER"),
        description: t("CLIENT_MANAGER_DESCRIPTION"),
      },
    },
  },
  status: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("STATUS"),
      description: t("CLIENT_STATUS_DESCRIPTION"),
    },
  },
  reseller: {
    id: {
      "ui:options": {
        label: t("CONTRACT_OWNER"),
        description: t("CLIENT_OWNER_DESCRIPTION"),
      },
    },
  },
  sector: {
    "ui:widget": "hidden",
  },
  industry: {
    id: {
      "ui:widget": "hidden",
    },
    "ui:widget": "hidden",
  },
});
